/*********************** ShopHelten Theme Translation Module ************************/
/**
 * Theme Translation Module for Service Agreements and Add-ons
 * Translates Danish service agreement content to EN / SV
 * ShopHelten (2025)
 */

(function () {
    'use strict';

    /**********************************************************
     * TRANSLATION DICTIONARY
     **********************************************************/
    const translations = {
      en: {
        // --- Service Agreement Add-on Elements ---
        'Tilkøb serviceaftale - Privat/Erhverv': 'Add service agreement - Private/Business',
        'Inkluderer fri mailsupport, fri telefonsupport, fri teamviewer support, fri returfragt til vores butik, hvis der er behov for rep. eller service.': 'Includes free email support, free phone support, free TeamViewer support, free return shipping to our store if repair or service is needed.',
        'Læs mere': 'Read more',
        'Serviceavtal för 3D-skrivare - Privat - Välj 1, 2 eller 3 år': 'Service agreement for 3D printers - Private - Choose 1, 2 or 3 years',
        'Serviceavtal för 3D-skrivare - Företag - Välj 1, 2 eller 3 år.': 'Service agreement for 3D printers - Business - Choose 1, 2 or 3 years.',
        '1 år': '1 year',
        '2 år': '2 years',
        '3 år': '3 years',

        // --- Service Agreement Modal Content ---
        'Vælg serviceaftale - Din garanti for tryghed': 'Choose service agreement - Your guarantee for security',
        'Det er ikke helt uden grund, at vi er den mest anbefalede virksomhed på Trustpilot inden for salg og service af 3D-printere, laser og andre maskiner. Herunder kan du se, hvad du får med en serviceaftale hos 3D Eksperten.': 'It\'s not without reason that we are the most recommended company on Trustpilot for sales and service of 3D printers, lasers and other machines. Below you can see what you get with a service agreement at 3D Eksperten.',
        '1 års serviceaftale inkluderer:': '1 year service agreement includes:',
        'Fri mailsupport': 'Free email support',
        'Fri telefonsupport': 'Free phone support',
        'Fri TeamViewer-support med starthjælp til opsætning af software': 'Free TeamViewer support with startup help for software setup',
        'Fri returfragt til vores servicecenter ved behov for reparation eller service*': 'Free return shipping to our service center when repair or service is needed*',
        'Du adgang til en omfattende servicepakke, der ikke kun sikrer dig teknisk assistance, men også leverer enestående kundesupport. Med vores serviceaftale får du fri mail-, telefon- og TeamViewer-support med starthjælp til opsætning af software.': 'You get access to a comprehensive service package that not only ensures technical assistance, but also delivers exceptional customer support. With our service agreement you get free email, phone and TeamViewer support with startup help for software setup.',
        'Ved eventuelle problemer med din maskine tilbyder vi fri fragt til vores servicecenter.': 'In case of any problems with your machine, we offer free shipping to our service center.',
        'Det eneste krav er, at du gemmer og anvender den oprindelige emballage ved returnering for at sikre en sikker transport uden skader.': 'The only requirement is that you keep and use the original packaging when returning to ensure safe transport without damage.',
        'Hvorfor vælge en serviceaftale hos 3D Eksperten?': 'Why choose a service agreement at 3D Eksperten?',
        'Professionel og erfaringsbaseret support': 'Professional and experience-based support',
        'Fri fragt og nem returproces': 'Free shipping and easy return process',
        'Omfattende dækning af teknisk support og hjælp til software opsætning': 'Comprehensive coverage of technical support and help with software setup',
        'En serviceaftale fra 3D Eksperten tilbyder ikke kun ekstra tryghed, men også en pålidelig partner, der er dedikeret til at sikre, at du får en god oplevelse.': 'A service agreement from 3D Eksperten offers not only extra security, but also a reliable partner who is dedicated to ensuring you have a good experience.',
        'Ring til vores kundeservice på': 'Call our customer service at',
        'og oplev den forskel, en serviceaftale fra 3D Eksperten kan gøre.': 'and experience the difference a service agreement from 3D Eksperten can make.',
        'Bemærk: Serviceaftalen dækker ikke selvforskyldte skader, fejlagtig brug, mishandling, lakskader, misfarvninger, ridser eller forbrugsmaterialer. Tryghedsaftalen er gældende fra aftalens indgåelse/oprettelse og en aftale gælder kun én maskine.': 'Note: The service agreement does not cover self-inflicted damage, incorrect use, mishandling, paint damage, discoloration, scratches or consumables. The security agreement is valid from the conclusion/creation of the agreement and an agreement only applies to one machine.',
        'Er du erhverv, er din serviceaftale kun gældende, hvis du vælger erhvervsaftalen.': 'If you are a business, your service agreement is only valid if you choose the business agreement.',
        'Vær opmærksom på, er printeren blevet leveret på en palle (Eksempelvis Creality K2 Plus (combo) og Bambu Lab H2D (Combo), vil der blive opkrævet pallefragt ved normalt serviceeftersyn - gælder naturligvis ikke ved reklamationer.': 'Please note, if the printer has been delivered on a pallet (e.g. Creality K2 Plus (combo) and Bambu Lab H2D (Combo), pallet shipping will be charged for normal service inspection - naturally does not apply to complaints.'
      },

      sv: {
        // --- Service Agreement Add-on Elements ---
        'Tilkøb serviceaftale - Privat/Erhverv': 'Lägg till serviceavtal - Privat/Företag',
        'Inkluderer fri mailsupport, fri telefonsupport, fri teamviewer support, fri returfragt til vores butik, hvis der er behov for rep. eller service.': 'Inkluderar gratis e-postsupport, gratis telefonsupport, gratis TeamViewer-support, gratis returfrakt till vår butik om reparation eller service behövs.',
        'Læs mere': 'Läs mer',
        'Serviceavtal för 3D-skrivare - Privat - Välj 1, 2 eller 3 år': 'Serviceavtal för 3D-skrivare - Privat - Välj 1, 2 eller 3 år',
        'Serviceavtal för 3D-skrivare - Företag - Välj 1, 2 eller 3 år.': 'Serviceavtal för 3D-skrivare - Företag - Välj 1, 2 eller 3 år.',
        '1 år': '1 år',
        '2 år': '2 år',
        '3 år': '3 år',

        // --- Service Agreement Modal Content ---
        'Vælg serviceaftale - Din garanti for tryghed': 'Välj serviceavtal - Din garanti för trygghet',
        'Det er ikke helt uden grund, at vi er den mest anbefalede virksomhed på Trustpilot inden for salg og service af 3D-printere, laser og andre maskiner. Herunder kan du se, hvad du får med en serviceaftale hos 3D Eksperten.': 'Det är inte utan anledning att vi är det mest rekommenderade företaget på Trustpilot inom försäljning och service av 3D-skrivare, laser och andra maskiner. Nedan kan du se vad du får med ett serviceavtal hos 3D Eksperten.',
        '1 års serviceaftale inkluderer:': '1 års serviceavtal inkluderar:',
        'Fri mailsupport': 'Gratis e-postsupport',
        'Fri telefonsupport': 'Gratis telefonsupport',
        'Fri TeamViewer-support med starthjælp til opsætning af software': 'Gratis TeamViewer-support med starthjälp för mjukvaruinstallation',
        'Fri returfragt til vores servicecenter ved behov for reparation eller service*': 'Gratis returfrakt till vårt servicecenter vid behov av reparation eller service*',
        'Du adgang til en omfattende servicepakke, der ikke kun sikrer dig teknisk assistance, men også leverer enestående kundesupport. Med vores serviceaftale får du fri mail-, telefon- og TeamViewer-support med starthjælp til opsætning af software.': 'Du får tillgång till ett omfattande servicepaket som inte bara säkerställer teknisk assistans, utan också leverer exceptionell kundsupport. Med vårt serviceavtal får du gratis e-post-, telefon- och TeamViewer-support med starthjälp för mjukvaruinstallation.',
        'Ved eventuelle problemer med din maskine tilbyder vi fri fragt til vores servicecenter.': 'Vid eventuella problem med din maskin erbjuder vi gratis frakt till vårt servicecenter.',
        'Det eneste krav er, at du gemmer og anvender den oprindelige emballage ved returnering for at sikre en sikker transport uden skader.': 'Det enda kravet är att du sparar och använder den ursprungliga förpackningen vid retur för att säkerställa en säker transport utan skador.',
        'Hvorfor vælge en serviceaftale hos 3D Eksperten?': 'Varför välja ett serviceavtal hos 3D Eksperten?',
        'Professionel og erfaringsbaseret support': 'Professionell och erfarenhetsbaserad support',
        'Fri fragt og nem returproces': 'Gratis frakt och enkel returprocess',
        'Omfattende dækning af teknisk support og hjælp til software opsætning': 'Omfattande täckning av teknisk support och hjälp med mjukvaruinstallation',
        'En serviceaftale fra 3D Eksperten tilbyder ikke kun ekstra tryghed, men også en pålidelig partner, der er dedikeret til at sikre, at du får en god oplevelse.': 'Ett serviceavtal från 3D Eksperten erbjuder inte bara extra trygghet, utan också en pålitlig partner som är dedikerad till att säkerställa att du får en bra upplevelse.',
        'Ring til vores kundeservice på': 'Ring till vår kundservice på',
        'og oplev den forskel, en serviceaftale fra 3D Eksperten kan gøre.': 'och upplev skillnaden ett serviceavtal från 3D Eksperten kan göra.',
        'Bemærk: Serviceaftalen dækker ikke selvforskyldte skader, fejlagtig brug, mishandling, lakskader, misfarvninger, ridser eller forbrugsmaterialer. Tryghedsaftalen er gældende fra aftalens indgåelse/oprettelse og en aftale gælder kun én maskine.': 'Observera: Serviceavtalet täcker inte självförvållade skador, felaktig användning, misshandel, färgskador, missfärgningar, repor eller förbruksmaterial. Trygghetsavtalet är giltigt från avtalets ingående/skapande och ett avtal gäller endast en maskin.',
        'Er du erhverv, er din serviceaftale kun gældende, hvis du vælger erhvervsaftalen.': 'Om du är företag är ditt serviceavtal endast giltigt om du väljer företagsavtalet.',
        'Vær opmærksom på, er printeren blevet leveret på en palle (Eksempelvis Creality K2 Plus (combo) och Bambu Lab H2D (Combo), vil der blive opkrævet pallefragt ved normalt serviceeftersyn - gælder naturligvis ikke ved reklamationer.': 'Var uppmärksam på att om skrivaren har levererats på en pall (t.ex. Creality K2 Plus (combo) och Bambu Lab H2D (Combo), kommer pallfrakt att debiteras vid normal serviceinspektion - gäller naturligtvis inte vid reklamationer.'
      }
    };

    /**********************************************************
     * CORE HELPERS
     **********************************************************/
    function getCurrentLanguage() {
      const htmlLang = document.documentElement.lang;
      if (htmlLang?.startsWith('sv')) return 'sv';
      if (htmlLang?.startsWith('en')) return 'en';
      return 'da';
    }

    function translatePlainText(text, lang) {
      if (!text || lang === 'da') return text;
      const t = text.trim();
      return translations[lang][t] || t;
    }

    function setElementTextIfChanged(element, newText) {
      if (element && newText && element.textContent.trim() !== newText) {
        element.textContent = newText;
      }
    }

    function translateElementContent(element, lang) {
      if (!element || lang === 'da') return;

      // Translate text content
      const originalText = element.textContent.trim();
      if (originalText) {
        const translatedText = translatePlainText(originalText, lang);
        setElementTextIfChanged(element, translatedText);
      }

      // Translate attributes
      const attributesToTranslate = ['title', 'alt', 'aria-label', 'placeholder'];
      attributesToTranslate.forEach(attr => {
        const value = element.getAttribute(attr);
        if (value) {
          const translated = translatePlainText(value, lang);
          if (translated !== value) {
            element.setAttribute(attr, translated);
          }
        }
      });
    }

    /**********************************************************
     * SERVICE AGREEMENT ADD-ON TRANSLATION
     **********************************************************/
    function translateServiceAddonElements() {
      const lang = getCurrentLanguage();
      if (lang === 'da') return;

      // Translate add-on title
      document.querySelectorAll('.ast-addon-title').forEach((el) => {
        translateElementContent(el, lang);
      });

      // Translate add-on subtitle
      document.querySelectorAll('.ast-addon-subtitle').forEach((el) => {
        translateElementContent(el, lang);
      });

      // Translate "Læs mere" links
      document.querySelectorAll('.readmore').forEach((el) => {
        translateElementContent(el, lang);
      });

      // Translate product titles in add-on items
      document.querySelectorAll('.ast-addon-item-title span').forEach((el) => {
        translateElementContent(el, lang);
      });

      // Translate select options
      document.querySelectorAll('.ast-select option').forEach((el) => {
        translateElementContent(el, lang);
      });

      // Translate alt text on images
      document.querySelectorAll('.ast-addon-image').forEach((el) => {
        translateElementContent(el, lang);
      });
    }

    /**********************************************************
     * SERVICE AGREEMENT MODAL TRANSLATION
     **********************************************************/
    function translateServiceModalContent() {
      const lang = getCurrentLanguage();
      if (lang === 'da') return;

      const modal = document.querySelector('.custom-model-main');
      if (!modal) return;

      // Translate all text content in the modal
      const textElements = modal.querySelectorAll('h3, h4, p, li, i, a, strong');
      textElements.forEach((el) => {
        // Skip elements that contain only phone numbers or specific formatting
        if (el.textContent.includes('+45') || el.textContent.includes('tel:')) {
          return;
        }

        const originalText = el.textContent.trim();
        if (originalText) {
          let translatedText = originalText;

          // Handle specific patterns that need special translation
          if (originalText.includes('Ring til vores kundeservice på')) {
            const phoneMatch = originalText.match(/Ring til vores kundeservice på\s+(.+?)\s+og oplev/);
            if (phoneMatch) {
              const phoneNumber = phoneMatch[1];
              if (lang === 'en') {
                translatedText = `Call our customer service at ${phoneNumber} and experience`;
              } else if (lang === 'sv') {
                translatedText = `Ring till vår kundservice på ${phoneNumber} och upplev`;
              }
            }
          } else {
            translatedText = translatePlainText(originalText, lang);
          }

          setElementTextIfChanged(el, translatedText);
        }
      });

      // Handle specific text patterns that span multiple elements
      const modalText = modal.textContent;
      
      // Translate phone number context
      if (modalText.includes('Ring til vores kundeservice på')) {
        const phoneLink = modal.querySelector('a[href^="tel:"]');
        if (phoneLink) {
          const phoneNumber = phoneLink.textContent;
          const parentText = phoneLink.parentElement.textContent;
          
          if (lang === 'en') {
            const newText = parentText.replace('Ring til vores kundeservice på', 'Call our customer service at')
                                     .replace('og oplev den forskel', 'and experience the difference');
            phoneLink.parentElement.innerHTML = newText.replace(phoneNumber, `<a href="tel:${phoneNumber}" style="color: blue; text-decoration: underline;">${phoneNumber}</a>`);
          } else if (lang === 'sv') {
            const newText = parentText.replace('Ring til vores kundeservice på', 'Ring till vår kundservice på')
                                     .replace('og oplev den forskel', 'och upplev skillnaden');
            phoneLink.parentElement.innerHTML = newText.replace(phoneNumber, `<a href="tel:${phoneNumber}" style="color: blue; text-decoration: underline;">${phoneNumber}</a>`);
          }
        }
      }
    }

    /**********************************************************
     * MASTER FUNCTION
     **********************************************************/
    function translateAllThemeElements() {
      translateServiceAddonElements();
      translateServiceModalContent();
    }

    /**********************************************************
     * OBSERVER — retranslate on dynamic DOM updates
     **********************************************************/
    const observer = new MutationObserver(() => translateAllThemeElements());
    observer.observe(document.body, { childList: true, subtree: true });

    // Initial translation
    document.addEventListener('DOMContentLoaded', translateAllThemeElements);

    // Also run immediately in case DOM is already loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', translateAllThemeElements);
    } else {
      translateAllThemeElements();
    }
})();
